import isMobile from 'ismobilejs'

export const useIsMobileDevice = () => {
  const isMobileDevice =
    isMobile(window.navigator).apple.phone ||
    isMobile(window.navigator).android.phone

  return { isMobileDevice }
}
